import {
    createRouter as createTanstackRouter,
    Router,
} from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { QueryClient } from '@tanstack/query-core';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';
import { DefaultError } from './components/DefaultError';
import { DefaultLoader } from './components/DefaultLoader';
import { DefaultNotFound } from './components/DefaultNotFound';
import { ApiError } from './components/Providers/APIClient';

export function getRouter() {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 5 * 60_000,
                gcTime: 30 * 60_000,
                retryDelay: 1_000,
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                retry: (failureCount, error: Error) => {
                    if (
                        error instanceof ApiError &&
                        (error?.status === 404 || error?.status === 429)
                    )
                        return false;
                    return failureCount < 2;
                },
            },
        },
    });

    const router = createTanstackRouter({
        routeTree,
        context: { queryClient, auth: null },
        scrollRestoration: true,
        defaultStructuralSharing: true,
        getScrollRestorationKey: (location) =>
            location.pathname + location.hash,
        defaultErrorComponent: DefaultError,
        defaultNotFoundComponent: () => DefaultNotFound({}),
        defaultPendingComponent: DefaultLoader,
    });

    setupRouterSsrQueryIntegration({
        router,
        queryClient,
    });

    return router;
}

declare module '@tanstack/react-router' {
    interface Register {
        router: Router<typeof routeTree>;
    }
}
